import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import LogoIcon from 'material-ui-icons/WifiTethering';
import colors from '../../config/themeColors';

const styles = theme => ({
    container: {
        width: 1160,
        height: '100%',
        backgroundColor: '#fff',
        margin: '80px auto 0 auto',
        boxShadow: 'none',
        maxWidth: 'calc(100% - 20px)',
        [theme.breakpoints.up('md')]: {
            maxWidth: 'calc(100% - 64px)',
            margin: '0 auto 0 auto',
            boxShadow: '-8px 0 5px -5px rgba(0, 0, 0, 0.12)',
        },
    },
    logo: {
        width: '28px',
        height: '20px',
    },
    paper: {
        display: 'flex',
        justifyContent: 'center',
        padding: 0,
        margin: 32,
    },
    toolbar: {
        position: 'fixed',
        left: 0,
        top: 0,
        width: '64px',
        height: '100%',
        backgroundColor: colors.black,
        color: colors.white,
        display: 'none',
        textAlign: 'center',
        paddingTop: '28px',
        boxShadow: '0 2px 10px 0 rgba(0, 0, 0, 0.5);',
        [theme.breakpoints.up('md')]: {
            display: 'block',
        },
    },
});

function PageWrapper({ classes, children }) {
    return (
        <div>
            <div className={classes.toolbar}>
                <LogoIcon />
            </div>
            <div className={classes.container}>
                {children}
            </div>
        </div>
    );
}

PageWrapper.propTypes = {
    classes: PropTypes.object.isRequired,
    children: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.object,
    ]).isRequired,
};

export default withStyles(styles)(PageWrapper);



// WEBPACK FOOTER //
// ./src/app/layout/PageWrapper.js